export default __webpack_public_path__ + "static/media/ic_right_0.e90fc0c0.svg";